<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.units") }}</h3>
            </div>
            <div class="card-body">
                <button
                    class="btn btn-sm btn-primary mb-3"
                    @click="openUnitModal()"
                >
                    <span class="text-white fs-6 fw-bold">{{ $t("unit.add") }}</span>
                </button>
                <table class="table table-sm table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("unit.name") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="units.length">
                        <tr v-for="unit in paginatedUnits" :key="unit.id" class="align-middle">
                            <td>{{ unit.name }}</td>
                            <td>
                                <button
                                    class="btn btn-secondary btn-sm me-2"
                                    @click="openUnitModal(unit)"
                                >
                                    <icon icon="EditPen"></icon>
                                </button>
                                <button
                                    class="btn btn-danger btn-sm"
                                    @click="deleteUnit(unit)"
                                >
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="2" class="text-center text-muted py-3">
                                {{ $t("unit.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="units.length >=5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="unitModal" tabindex="-1" aria-hidden="true" ref="unitModal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">
                        {{ modalUnitTitle }}
                    </h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form class="row g-3">
                        <div class="col-12">
                            <label for="name" class="form-label fw-bold">{{ $t("unit.name") }}</label>
                            <input type="text" class="form-control" id="name" v-model="unit.name" required>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary text-white fs-6 fw-bold" @click="saveUnit">
                        {{ $t("utils.save") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { Modal } from 'bootstrap';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    data() {
        return {
            units: [],
            unit: {},
            isEditing: false,
            unitModal: null,
            modalUnitTitle: null,
            currentPage: 1,
            perPage: 10
        }
    },
    created() {
        this.getGatehouse();
    },
    mounted() {
        this.unitModal = new Modal(this.$refs.unitModal);
    },
    methods: {
        getGatehouse() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/gatehouse`)
            .then(response => {
                this.gatehouse = response.data;
                this.getUnits();
            })
            .catch(error => {
                console.error("Error loading gatehouse. ", error)
            });
        },
        getUnits() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/units`)
            .then(res => {
                this.units = res.data;
            })
            .catch(error => {
                console.error("Error loading commodity units. ", error)
            });
        },
        openUnitModal(unit) {
            if (unit) {
                this.modalUnitTitle = this.$t("unit.edit")
                this.unit = {...unit};
                this.isEditing = true;
            } else {
                this.modalUnitTitle = this.$t("unit.add")
                this.unit = { name: "" };
                this.isEditing = false;
            }
            this.unitModal.show();
        },
        saveUnit() {
            if (this.isEditing) {
                // EDIT
                this.$store.getters.api.put(`/dashboard/${this.$route.params.slug}/units/${this.unit.id}/edit`, this.unit)
                .then(() => {
                    this.getUnits();
                    this.unitModal.hide();
                })
                .catch(error => {
                    console.error("Error updating unit.", error);
                });
            } else {
                // ADD
                this.$store.getters.api.post(`/dashboard/${this.$route.params.slug}/units/add`, this.unit)
                .then(() => {
                    this.getUnits();
                    this.unitModal.hide();
                })
                .catch(error => {
                    console.error("Error adding unit.", error);
                });
            }
        },
        deleteUnit(unit) {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: unit.name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/units/${unit.id}/delete`)
            .then(() => {
                this.getUnits();
            })
            .catch(error => {
                console.error("Error deleting unit.", error);
            });
        },
    },
    computed: {
        gatehouseId() {
            return this.gatehouse.id;
        },
        paginatedUnits() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.units.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.units.length / this.perPage);
        }
    }
}
</script>

<style scoped>
.modal_wrapper {
  background-color: #fff;
}
</style>